<template>
<div>
    <p v-if="description" class="pt-1 pt-sm-0 pb-0 mb-0">
        <span v-if="description.founded" class="font-weight-bold">Founded:</span>
        {{ description.founded }}
    </p>
    <p v-if="description" class="pt-0">
        <span v-if="description.publishedby" class="font-weight-bold">Published by:</span>
        {{ description.publishedby }}
    </p>
    <div v-if="description" class="mt-3 text-justify"
        v-html="description.text">
    </div>
    <app-footer-home-journal v-if="journal_id != 3"></app-footer-home-journal>
    <app-footer-home-journal-bohemica v-else></app-footer-home-journal-bohemica>

</div>

</template>
<script>
import footerHomeJournal from './FooterHomeJournal.vue';
import appFooterHomeJournalBohemica from './FooterHomeJournalBohemica.vue';
import {mapGetters} from 'vuex';
export default {
    data() {
        return {
            journal_id :null,
        }
    },
    created(){
        this.journal_id = this.$route.params.journal_id
    },
        components:{
            'AppFooterHomeJournal':footerHomeJournal,
            'AppFooterHomeJournalBohemica':appFooterHomeJournalBohemica,
        },
        computed:{
        ...mapGetters('library',{
            description:'description'
        })
    },
}
</script>
